<template>
  <div>
    <div ref="anchor">

    </div>
    <div>
        <div class="menu">

            <div class="opcion">
                <h5 class="titulo">CLASIFICACIÓN</h5>                
                <ul v-if="clasificacionSeleccionada == undefined">
                    <li class="item" v-for="(item,idx) in clasificaciones" :key="idx" @click="seleccionarClasificacion(item)">{{item.descripcion}}</li>
                </ul>
                <div v-else>
                    <div class="item-seleccionado">
                        {{ clasificacionSeleccionada.descripcion }} 
                        <a role="button" @click="deseleccionarClasificacion()">
                            <span class="fa fa-times-circle"></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="opcion" v-if="clasificacionSeleccionada">
                <h5 class="titulo">CATEGORIA</h5>                
                <ul v-if="categoriaSeleccionada == undefined">
                    <li class="item" v-for="(item,idx) in categorias" :key="idx" @click="seleccionarCategoria(item)">{{item.descripcion}}</li>
                </ul>
                <div v-else>
                    <div class="item-seleccionado">
                        {{ categoriaSeleccionada.descripcion }} 
                        <a role="button" @click="deseleccionarCategoria()">
                            <span class="fa fa-times-circle"></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="opcion" v-if="categoriaSeleccionada">
                <h5 class="titulo">LINEA</h5>                
                <ul v-if="lineaSeleccionada == undefined">
                    <li class="item" v-for="(item,idx) in lineas" :key="idx" @click="seleccionarLinea(item)">{{item.descripcion}}</li>
                </ul>
                <div v-else>
                    <div class="item-seleccionado">
                        {{ lineaSeleccionada.descripcion }} 
                        <a role="button" @click="deseleccionarLinea()">
                            <span class="fa fa-times-circle"></span>
                        </a>
                    </div>
                </div>
            </div>

            <!-- <div>
                <h5>Categorias</h5>
                <ul>
                    <li></li>
                </ul>
            </div>

            <div>
                <h5>Lineas</h5>
                <ul>
                    <li></li>
                </ul>
            </div> -->
        </div> 
        <div class="contenido" v-if="articulos">            
            <div class="tarjeta" v-for="(a, idx) in articulos" :key="idx">
                <div class="img">
                    <img :src="'http://www.difarmer.com/imagenes/Difarmer/' + a.codArticulo + '.webp'">
                </div>                                                
                <div class="descripcion">
                    {{ a.descripcion }}                        
                </div>
                <div class="generico">
                    {{ a.formula }}
                </div>
                <div class="precio">
                    ${{ a.precioPublico | format-number('0,0.00')}}
                </div>
            </div>            
        </div>
        <div class="paginador" v-if="articulos.length > 0 ">
            <b-pagination
                v-model="pagina"
                :total-rows="totalPaginas"  
                per-page="24"              
                aria-controls="my-table"
                align="center"
                @change="cambiarPagina"
                ></b-pagination>
        </div>
        <div class="contenido" v-else>
            <div class="alert alert-warning">
                <i class="fa fa-info-circle mr-2"></i> No se encontro ningun articulo con los criterios seleccionados.
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import ServicioCatalogo from '@/services/servicio-catalogo'

export default {
    components:{
        
    },
    async mounted(){
        await this.cargarClasificaciones()     
        await this.cargarArticulos()   
    },
    data(){
        return{
            clasificacionSeleccionada: undefined,
            categoriaSeleccionada: undefined,
            lineaSeleccionada: undefined,
            clasificaciones:[],
            categorias:[],
            lineas:[],
            articulos:[],
            pagina: 1,
            totalPaginas: 0,
        }
    },
    methods:{      
        async cambiarPagina(pagina){
            this.pagina = pagina
            await this.cargarArticulos()
        },
        async cargarClasificaciones(){
            this.$loading(true)
            const r = await ServicioCatalogo.catclasificaciones()            
            this.clasificaciones = r.data
            this.$loading(false)    
            
            await this.cargarArticulos()
        },
        async cargarCategorias(){
            //console.log("clasificacion => ", this.clasificacionSeleccionada)

            this.$loading(true)
            const r = await ServicioCatalogo.catcategorias(this.clasificacionSeleccionada.codigo)
            this.categorias = r.data
            this.$loading(false)

            console.log(r)
            
        },
        async cargarLineas(){
            this.$loading(true)
            const r = await ServicioCatalogo.catlineas(this.clasificacionSeleccionada.codigo, this.categoriaSeleccionada.codigo)
            this.lineas = r.data
            this.$loading(false)

            //console.log("lineas =>", r)

        },
        async cargarArticulos(){    
            
            this.articulos = []

            let to = this.moveToDown
                ? this.$refs.anchor.offsetTop - 60
                : 0

            window.scroll({
                top: to,
                left: 0,
                behavior: 'smooth'
            })

            this.$loading(true)
            const clasifiacion = this.clasificacionSeleccionada ? this.clasificacionSeleccionada.codigo : 0;
            const categoria = this.categoriaSeleccionada ? this.categoriaSeleccionada.codigo : 0;
            const linea = this.lineaSeleccionada ? this.lineaSeleccionada.codigo : 0;

            const r = await ServicioCatalogo.catarticulos(clasifiacion, categoria, linea, this.pagina)
            this.articulos = r.result.data
            this.totalPaginas = r.totalPaginas;

            console.log("r => ", r)
            console.log("total-paginas => ", this.totalPaginas)

            this.$loading(false)            

        },
        async seleccionarClasificacion(item){
            this.clasificacionSeleccionada = item             
            
            await this.cargarCategorias()

            this.pagina = 1

            await this.cargarArticulos()
        },
        async deseleccionarClasificacion(){
            this.clasificacionSeleccionada = undefined
            this.categoriaSeleccionada = undefined
            this.lineaSeleccionada = undefined

            this.pagina = 1

            await this.cargarArticulos()
        },
        async seleccionarCategoria(item){
            this.categoriaSeleccionada = item

            await this.cargarLineas()

            this.pagina = 1

            await this.cargarArticulos()

        },        
        async deseleccionarCategoria(){            
            this.categoriaSeleccionada = undefined
            this.lineaSeleccionada = undefined

            this.pagina = 1

            await this.cargarArticulos()
        },
        async seleccionarLinea(item){
            this.lineaSeleccionada = item

            this.pagina = 1

            await this.cargarArticulos()
        },        
        async deseleccionarLinea(){            
            this.lineaSeleccionada = undefined

            this.pagina = 1

            await this.cargarArticulos()
        },
    }

}
</script>

<style lang="scss">
body{
    background: #eee;
}

.menu{
    padding: 1em;
    width: 300px;
    position: fixed;
    top: 0;        
    height: 100vh;
    background: #fff;
    box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.10);
    overflow: scroll;

    .opcion{
        font-size: 14px;
        padding-bottom: 2em;

        .titulo{
            font-size: 16px;
            font-weight: bold;
            color: rgb(44, 44, 240);

        }
        li{
            text-decoration: none;
            list-style: none;
            cursor: pointer;
            transition: all .1s ease;   
            padding: .3em 0em;  
            overflow: hidden;
            white-space: nowrap;

            &:hover{
                font-weight: bold;
                color: rgb(40, 40, 252);

                &::before{
                    border-left: blue solid 5px;
                    content: '';
                    padding-right: 0.5em;
                }
            }

            
        }

        .item-seleccionado{
            font-weight: bold;
            border-left: blue solid 5px;
            padding-left: 1em;
            font-size: 14px;

            span{
                font-size: 16px;
                padding-left: 0.5em;
                color: #aaa;

                &:hover{
                    color:red;
                }
            }
        }
        
    }
}

.paginador {
    margin-left: 300px;
    

}
.contenido {      
    margin-left: 300px;
    padding: 1em; 
    display: flex;   
    flex-wrap: wrap;
    justify-content: center;
    .tarjeta{
        margin: 0.5em;
        width: 350px;
        background: #fff;
        border: 1px solid #eee;
        padding: 2.5em 1em;
        border-radius: 15px;
        -webkit-box-shadow: 0px 0px 3px 3px rgba(0,0,0,0.24);
        -moz-box-shadow: 0px 0px 3px 3px rgba(0,0,0,0.24);
        box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.10);
        text-align: center;

        .img{            
            min-height: 250px;
            img{
                width: 200px;                
            }            
        }

        .descripcion{
            font-weight: bold;
            color:#777;            
        }

        .generico{
            font-size: 14px;
            color:#999;
            
        }

        .precio{
            padding-top: 1em;
            font-size: 1.5em;
            font-weight: bold;
            color:rgb(57, 106, 197);
        }
        
    }
}

</style>